import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartCommonModule, PieChartModule, BarChartModule } from '@swimlane/ngx-charts';

import { SgCommonModule } from '../../common.module';
import { PieArcBorder } from './arc-border.directive';
import { SgSecuritiesPieComponent } from './securities-pie/securities-pie.component';
import { SgSecuritiesPieDoughnutViewDirective } from './securities-pie/securities-pie-doughnut-view.directive';

const importsAndExports = [CommonModule, SgCommonModule, ChartCommonModule, PieChartModule, BarChartModule];

const declarationAndExports = [PieArcBorder, SgSecuritiesPieDoughnutViewDirective, SgSecuritiesPieComponent];

@NgModule({
  imports: [importsAndExports],
  declarations: [declarationAndExports],
  exports: [declarationAndExports, importsAndExports],
})
export class SgGraphModule {}
